import { render, staticRenderFns } from "./Register-4.vue?vue&type=template&id=2bf181aa&scoped=true&"
import script from "./Register-4.vue?vue&type=script&lang=js&"
export * from "./Register-4.vue?vue&type=script&lang=js&"
import style0 from "./Register-4.vue?vue&type=style&index=0&id=2bf181aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf181aa",
  null
  
)

export default component.exports